import Helpers from "../../helpers/helpers";
import { server } from "../globalSettings";

export const requestAuthOption = (method, data) => {
    let isRemember = localStorage.getItem("remember");
    let token = JSON.parse(localStorage.getItem("token"))

    if (data) {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, },
            body: JSON.stringify(data)
        };
        return requestOptions
    } else {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, },
        };
        return requestOptions
    }

}

export const categoryListingApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(
            `${server}category?paginate=${payload.paginate}&sort=${payload.sort_by}&sort_order=${payload.sort_order}&size=${payload.size}&search=${payload.search}&filter[status]=${payload.filterStatus}&filter[show_in_navigation_menu]=${payload.show_in_navigation_menu}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data.data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const categoryDetailsApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(
            `${server}category/${payload.id}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data.data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const addCategoryApi = async (payload) => {
    const request = requestAuthOption("POST", payload)
    try {
        const response = await fetch(
            `${server}category`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const updateCategoryApi = async (payload) => {
    const request = requestAuthOption("PUT", payload.data)
    try {
        const response = await fetch(
            `${server}category/${payload.id}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const bulkUpdateCategoryApi = async (payload) => {
    const request = requestAuthOption("POST", payload.data)
    try {
        const response = await fetch(
            `${server}category/bulk-edit`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const deleteCategoryApi = async (payload) => {
    const request = requestAuthOption("DELETE")
    try {
        const response = await fetch(
            `${server}category/${payload.id}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const bulkDeleteCategoryApi = async (payload) => {
    const request = requestAuthOption("POST", payload)
    try {
        const response = await fetch(
            `${server}category/bulk-delete`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const exportCategoryApi = async (payload) => {
    const request = requestAuthOption("POST", payload)
    try {
        const response = await fetch(
            `${server}category/export`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};
